import React, { useState } from 'react';

export default function LabeledInput({
  value,
  onChange,
  classNames = '',
  label = '',
  isRequired = false,
  isInvalid = false,
  ...restProps
}) {
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = e => {
    setInputValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className={classNames}>
      <div className={`mb-1 text-xs ${isInvalid ? '!text-theme-input-warning' : 'text-slate-600'}`}>
        {label}
        {isRequired ? <sup>*</sup> : ''}
      </div>
      <input
        {...restProps}
        value={inputValue}
        onChange={handleInputChange}
        className={`placeholder:text-text-slate-400 focus-ring-2 block w-full appearance-none rounded-md !border !border-solid bg-white px-3 py-2 hover:border-theme-input-focus focus:border-theme-input-focus focus:outline-none focus:ring-theme-input-focus sm:text-sm ${
          isInvalid ? '!border-theme-input-warning' : 'border-slate-200'
        }`}
      />
    </div>
  );
}
